<template>
  <div>

    <caseCompetency :center_execute_id="center_execute_id" :case_id="case_id"></caseCompetency>
  </div>
</template>

<script>
import caseCompetency from "./caseCompetency";
export default {
  name: "marking-competency-page",
  components: { caseCompetency },
  data() {
    return {
      center_execute_id: this.$route.params.center_execute_id || this.$route.params.centerExecuteId,
      case_id: this.$route.params.case_id || this.$route.params.caseId
    };
  }
};
</script>

<style>
</style>